import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7120545f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "month-totals-container" }
const _hoisted_2 = { class: "month-totals" }
const _hoisted_3 = { class: "titles d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Totais Do Mês", -1))
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = {
  key: 0,
  class: "flex-legend"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "budget-legend" }, "0%", -1))
const _hoisted_8 = { class: "budget-legend" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Orçamento ")
const _hoisted_10 = { class: "budget-legend--strong" }
const _hoisted_11 = { class: "budget-legend" }
const _hoisted_12 = {
  key: 2,
  class: "flex-legend"
}
const _hoisted_13 = { class: "legend" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-legend billed" }),
  /*#__PURE__*/_createElementVNode("p", { class: "legend-text" }, "Faturado")
], -1))
const _hoisted_15 = { class: "legend-number" }
const _hoisted_16 = { class: "legend" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-legend inbilling" }),
  /*#__PURE__*/_createElementVNode("p", { class: "legend-text" }, "Em Faturamento")
], -1))
const _hoisted_18 = { class: "legend-number" }
const _hoisted_19 = { class: "legend" }
const _hoisted_20 = { class: "legend-container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "legend-text" }, "Saldo", -1))
const _hoisted_22 = { class: "legend-number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_NoAccess = _resolveComponent("NoAccess")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.access)
      ? (_openBlock(), _createBlock(_component_NoAccess, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.salesChannelName), 1)
      ]),
      (_ctx.access)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.monthTotals.channelBudgetMask), 1)
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.monthTotals?.channelPercentage) + "%", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.access)
        ? (_openBlock(), _createBlock(_component_VChart, {
            key: 1,
            class: _normalizeClass([{ loadingClass: _ctx.loading }, "chart"]),
            ref: "chart",
            option: _ctx.options,
            autoresize: ""
          }, null, 8, ["class", "option"]))
        : _createCommentVNode("", true),
      (_ctx.access)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.monthTotals.channelRevenueMask), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.monthTotals.channelInvoiceMask), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", {
                  class: _normalizeClass(["box-legend", 
                _ctx.monthTotals.channelBalanceValue <= 0
                  ? 'balanceNegative'
                  : 'balance'
              ])
                }, null, 2),
                _hoisted_21
              ]),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.monthTotals.channelBalanceMask), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}